import { Injectable, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';

@Injectable()
export class BisualTitleStrategy extends TitleStrategy {
  private readonly title = inject(Title);

  override updateTitle(router_state: RouterStateSnapshot): void {
    const page_title = this.buildTitle(router_state);
    this.title.setTitle(`${page_title} | Bisual - ERP for Employees`);
  }
}
